import { IServiceRequestModel } from '../../../../models';
import {
  clearUpdateServiceDetails,
  updateServiceFail,
  updateServiceStarted,
  updateServiceSuccess
} from '../../../reducer/services/UpdateServiceReducer';
import { updateService } from '../../actionType/services/ServiceActionTypes';

import {
  ClearUpdateServiceDetails, UpdateServiceFailure,
  UpdateServiceFailurePayload,
  UpdateServiceRequest,
  UpdateServiceStarted,
  UpdateServiceSuccess,
  UpdateServiceSuccessPayload
} from '../../types/services/UpdateServiceTypes';

export const updateServiceRequest = (
  reqObject: IServiceRequestModel,
  serviceVersion: string
): UpdateServiceRequest => ({
  type: updateService.UPDATE_SERVICE,
  requestObject: reqObject,
  serviceVersion
});

/**
 * Update service started saga action
 * @returns service started action
 */
export const updateServiceStart = (): UpdateServiceStarted => ({
  type: updateServiceStarted.type
});

/**
 * Update service success saga action
 * @param payload :Service data
 * @returns success action
 */
export const updateServiceSuccessfull = (
  payload: UpdateServiceSuccessPayload
): UpdateServiceSuccess => ({
  type: updateServiceSuccess.type,
  payload
});

/**
 * Update Service Faild saga action
 * @param payload : error message
 * @returns Failure saga action
 */
export const updateServiceFailure = (
  payload: UpdateServiceFailurePayload
): UpdateServiceFailure => ({
  type: updateServiceFail.type,
  payload
});

/**
 * Clear Service saga action
 */
export const clearUpdateServiceData = (): ClearUpdateServiceDetails => ({
  type: clearUpdateServiceDetails.type
});
